var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 12,
    viewBox: "0 0 31 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_103_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.07599 0.818182H6.60724V8.03693C6.60724 8.68987 6.47798 9.24834 6.21946 9.71236C5.96425 10.1764 5.60464 10.531 5.14062 10.7763C4.67661 11.0182 4.13305 11.1392 3.50994 11.1392C2.93655 11.1392 2.42116 11.0348 1.96378 10.826C1.50971 10.6172 1.15009 10.3139 0.884943 9.91619C0.623106 9.51515 0.492188 9.02794 0.492188 8.45455H2.01847C2.01847 8.73627 2.0831 8.97988 2.21236 9.18537C2.34493 9.39086 2.52557 9.55161 2.75426 9.66761C2.98627 9.7803 3.25142 9.83665 3.54972 9.83665C3.87453 9.83665 4.14962 9.7687 4.375 9.63281C4.60369 9.49361 4.7777 9.28977 4.89702 9.02131C5.01634 8.75284 5.07599 8.42472 5.07599 8.03693V0.818182ZM17.6877 5.90909C17.6877 6.99621 17.4888 7.93087 17.0911 8.71307C16.6934 9.49195 16.1481 10.0919 15.4554 10.5128C14.766 10.9304 13.9822 11.1392 13.1039 11.1392C12.2222 11.1392 11.4351 10.9304 10.7424 10.5128C10.053 10.0919 9.50941 9.49029 9.11168 8.7081C8.71396 7.9259 8.51509 6.9929 8.51509 5.90909C8.51509 4.82197 8.71396 3.88897 9.11168 3.11008C9.50941 2.32789 10.053 1.72798 10.7424 1.31037C11.4351 0.889441 12.2222 0.678977 13.1039 0.678977C13.9822 0.678977 14.766 0.889441 15.4554 1.31037C16.1481 1.72798 16.6934 2.32789 17.0911 3.11008C17.4888 3.88897 17.6877 4.82197 17.6877 5.90909ZM16.1664 5.90909C16.1664 5.08049 16.0321 4.38281 15.7637 3.81605C15.4985 3.24598 15.1339 2.8151 14.6699 2.52344C14.2092 2.22846 13.6872 2.08097 13.1039 2.08097C12.5172 2.08097 11.9935 2.22846 11.5328 2.52344C11.0721 2.8151 10.7076 3.24598 10.4391 3.81605C10.1739 4.38281 10.0414 5.08049 10.0414 5.90909C10.0414 6.73769 10.1739 7.43703 10.4391 8.0071C10.7076 8.57386 11.0721 9.00473 11.5328 9.29972C11.9935 9.59138 12.5172 9.73722 13.1039 9.73722C13.6872 9.73722 14.2092 9.59138 14.6699 9.29972C15.1339 9.00473 15.4985 8.57386 15.7637 8.0071C16.0321 7.43703 16.1664 6.73769 16.1664 5.90909ZM19.987 0.818182L22.8208 9.1108H22.9352L25.769 0.818182H27.4295L23.7654 11H21.9906L18.3265 0.818182H19.987ZM30.4361 0.818182V11H28.8999V0.818182H30.4361Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_103_5",
    x: 0.492188,
    y: 0.678986,
    width: 29.9439,
    height: 14.4602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_103_5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLogo);
export default __webpack_public_path__ + "static/media/nav-logo.422749360d18402b5ebc4fb3570d58e2.svg";
export { ForwardRef as ReactComponent };